<template>
  <div v-if="info.id" @click="goNewretail(info)">
    <div class="productCard">
      <div class="newr-tag"></div>
      <!--<div class="productImage" :style="'background-image:url(' + info.mainImage + ')'"></div>-->
      <el-image class="productImage" :src="info.mainImage" fit="contain"></el-image>
      <div class="productDetail">
        <p class="productName" v-text="info.name"></p>
        <div class="productDiscount" v-html="change(info.advertise)"></div>
        <div class="proDeBot">
          <p class="productPrice">
            {{
              info.activityItemInfoDto &&
              info.activityItemInfoDto.activityItemDtoList &&
              info.activityItemInfoDto.activityItemDtoList[0].itemExtDto
                ? info.activityItemInfoDto.activityItemDtoList[0].itemExtDto.activityPrice
                : info.price | currency('￥', 2) | currency('￥', 2)
            }}
          </p>
          <!-- <el-button type="danger">立即抢购</el-button> -->
        </div>
      </div>
    </div>
  </div>
  <div class="productCardJust" v-else>
    <div class="onlyProductImage" :style="'background-image:url(' + info.mainImage + ')'"></div>
  </div>
</template>
<style></style>
<script>
import { ActivityRoute } from '@/lib/utils'
// import { Button } from 'element-ui'
export default {
  data() {
    return {}
  },
  props: ['info'],
  components: {
    // ElButton: Button
  },
  watch: {},
  computed: {},
  methods: {
    // 进入商品详情页
    goNewretail(info) {
      let url = ActivityRoute(info).url + info.id
      this.$router.push(url)
    },
    change: function(content) {
      if (content) {
        content = content.replace(/\s/g, '</br>')
        return content
      }
    }
  },
  created() {},
  mounted() {}
}
</script>
<style lang="scss" scoped>
.productCard {
  // text-decoration: none;
  // position: relative;
  .sukText {
    position: absolute;
    left: 0;
    top: 0;
    height: 22px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    line-height: 22px;
    margin: 10px 0 0 20px;
    span {
      color: #c6001f;
    }
  }
}
.productCardJust {
  cursor: default;
  // text-decoration: none;
  // position: relative;
  .sukText {
    position: absolute;
    left: 0;
    top: 0;
    height: 22px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    line-height: 22px;
    margin: 10px 0 0 20px;
    span {
      color: #c6001f;
    }
  }
}
.newr-card:hover {
  // cursor: pointer;
  top: -3px;
  box-shadow: 0px 4px 10px 0px rgba(27, 50, 71, 0.22);
}
.newr-tag {
  z-index: 2;
  height: 59px;
  width: 60px;
  background-size: 60px 59px;
  background-repeat: no-repeat;
  background-image: url('../../../assets/images/mall/newretail.png');
  position: absolute;
  top: 0px;
  right: 0px;
}
.productImage {
  width: 259px;
  height: 150px;
  overflow: hidden;
  margin-right: 1px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.onlyProductImage {
  width: 259px;
  height: 315px;
  overflow: hidden;
  margin-right: 1px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.productDetail {
  .productName {
    margin-top: 10px;
    padding: 0px 20px;
    color: #000000;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .productDiscount {
    height: 60px;
    box-sizing: border-box;
    padding-top: 5px;
    margin-top: 8px;
    // margin-bottom: 10px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: #666666;
    padding: 0px 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // display: block;
    // display:-webkit-box;
    // /* autoprefixer: off */
    // -webkit-box-orient: vertical; // 参考
    // /* autoprefixer: on */
    // -webkit-line-clamp:2;
  }
  .typePrice {
    margin: 30px 0;
    padding: 0px 20px;
    font-size: 20px;
    font-weight: 400;
    color: #C6001F//#C6001F;
  }
  .productPrice {
    margin: 7px 0;
    padding: 0px 20px;
    font-size: 16px;
    font-weight: 500;
    color: #C6001F//#C6001F;
  }
  // .proDe .productPrice {
  //   // margin-top: 30px;
  // }
  ::v-deep {
    .el-button--danger {
      background-color: #c6001f; //#C6001F;
      border-color: #c6001f;
    }
    .el-button {
      width: 220px;
      height: 40px;
      border-radius: 0;
      margin-left: 20px;
    }
  }
}
</style>
